import { Frequency } from '@sportybot-web/services/sporty-gateway/generated/graphql';
import { z } from 'zod';

export const rulesSearchSchema = z.object({
  allRules: z.boolean().default(true),
  enabled: z.boolean().nullable().default(true),
  frequency: z.enum(Frequency).optional(),
  limit: z.number().default(10),
  page: z.number().default(0),
});

export type RuleFilters = z.infer<typeof rulesSearchSchema>;
